






import { Component, Vue } from 'vue-property-decorator'

import MasterLayout from '@/views/layouts/master.vue'

@Component({
  name: 'App',
  components: {
    MasterLayout
  }
})
export default class App extends Vue {
}
